/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    export class PsPromoApDtEditor extends Serenity.Extensions.GridEditorBase<PsPromoApDtRow> {
        protected getColumnsKey() { return "SalePromoCamp.PsPromoApDt"; }
        protected getDialogType() { return PsPromoApDtDialog; }
        protected getLocalTextPrefix() { return PsPromoApDtRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
                       
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

